import { useMemo } from 'react'
import useTrans from '../../../hooks/useTrans'
import { priceNotation } from '../../../utils/safe'

const DettagliProdottoListinoConfezionamento = ({ prezzi }) => {
  const t = useTrans()

  const isGratuito = (item) => {
    return item?.prezzi_confezionamento?.[0]?.prezzo == 0
  }

  const confezionamenti = useMemo(() => {
    const allPersonalizzazioni = prezzi.tecniche.flatMap((tecnica) =>
      tecnica.posizioni.flatMap((posizione) =>
        posizione.numero_colori.flatMap((numeroColore) => numeroColore.personalizzazioni_objects)
      )
    )

    // per ogni confezionamento mi salvo la prima personalizzazione
    const uniqueConfezionamentoMap = allPersonalizzazioni.reduce((accumulator, currentObject) => {
      const confezionamentoId = currentObject.confezionamento.id
      if (!accumulator[confezionamentoId]) {
        accumulator[confezionamentoId] = currentObject
      }
      return accumulator
    }, {})

    const uniqueObjects = Object.values(uniqueConfezionamentoMap)

    return uniqueObjects
  }, [prezzi])

  return (
    <div className="dettagli-prodotto__listino">
      {confezionamenti?.map((item, i) => {
        return (
          <div className="dettagli-prodotto__listino__block" key={i}>
            {isGratuito(item) ? (
              <div className="dettagli-prodotto__disclaimer" key={`chunk-${i}`}>
                *{item.confezionamento.nome} ({t('Senza costi aggiuntivi')})
              </div>
            ) : (
              <>
                {/* Titolo confezionamento */}
                <div className="dettagli-prodotto__listino__header">
                  <h3
                    className={`dettagli-prodotto__listino__title ${
                      i == 0 ? 'dettagli-prodotto__listino__title__first' : ''
                    } `}
                  >
                    {item.confezionamento.nome}
                  </h3>
                </div>

                {/* Tabella */}
                <div className="dettagli-prodotto__listino__wrapper">
                  <table className="dettagli-prodotto__listino__table">
                    <thead>
                      <tr className="dettagli-prodotto__listino__table__head__row">
                        {item.prezzi_confezionamento.map((p, idx) => (
                          <th key={idx}>{`${p.a_partire_da}+`}</th>
                        ))}
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        {item.prezzi_confezionamento?.map((obj, idx) => (
                          <td key={idx} className="dettagli-prodotto__listino__table__value">
                            {priceNotation(obj.prezzo, 3)} €
                          </td>
                        ))}
                      </tr>
                    </tbody>
                  </table>
                </div>
              </>
            )}
          </div>
        )
      })}
    </div>
  )
}

export default DettagliProdottoListinoConfezionamento
